import {TextInput} from 'components/forms/Inputs';
import React from 'react';

const RoleForm = () => {
  return (
    <React.Fragment>
      <TextInput required fullWidth label="Name" name="name" autoFocus />
    </React.Fragment>
  );
};

export default RoleForm;
